import MuiAlert from '@mui/material/Alert';

export default function AlertComponent({ sx, ...props }) {
  return <MuiAlert sx={{ borderRadius: 0, ...sx }} {...props} />;
}
